export default __webpack_public_path__ + "static/media/privredna_komora_logo.42a72f13.svg";